import {AfterViewInit, OnChanges, OnInit, ChangeDetectorRef} from '@angular/core';
import {FiltersComponent} from '../filters.component';
import {SelectOption} from '../../forms/select/select.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CommunicationService} from '../../../services/communication.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ListingsService} from '../../../services/listings.service';
import {PreferencesService} from '../../../services/preferences.service';
import {Filters} from '../../../classes/user-preferences';
import { debounceTime } from 'rxjs/operators';
import {UpdatedSince} from "../../../classes/enums";

export abstract class FiltersCommercialComponent extends FiltersComponent implements AfterViewInit, OnInit, OnChanges {
  isPricePerSqft: boolean;
  showListingTypes: boolean = false;
  showAllListingTypes: boolean = false;

  showBusinessTypes: boolean = false;
  showAllBusinessTypes: boolean = true;

  businessType = [];


  listingType = [
    'commercial',
    'farm',
    'businessOpportunity',
    'hotelResort',
    'commercialLease',
    'vacantLand'
  ];

  priceOptions: SelectOption[] = <any[]>[
    {key: 'filters.primary-price', value: 0},
    {key: 'filters.per-sqft', value: 1}
  ];

  pricePerSqftValues = Array.apply(null, {length: 21}).map((a, b) => b * 5);

  sqftOptions: SelectOption[] = <any[]>[
    {key: 'filters.square-feet', value: {}, disabled: true},
    {key: 'filters.any', value: {}},
    {text: '100+', value: {min: 100}},
    {text: '1,000+', value: {min: 1000}},
    {text: '10,000+', value: {min: 10000}},
    {text: '1,000,000+', value: {min: 1000000}}
  ];

  storiesOptions: SelectOption[] = <any[]>[
    {key: 'filters.stories', value: {}, disabled: true},
    {key: 'filters.any', value: {}},
    {text: '2+', value: {min: 2}},
    {text: '10+', value: {min: 10}},
    {text: '100+', value: {min: 100}}
  ];

  unitsOptions: SelectOption[] = <any[]>[
    {key: 'filters.units', value: {}, disabled: true},
    {key: 'filters.any', value: {}},
    {text: '10+', value: {min: 10}},
    {text: '100+', value: {min: 100}},
    {text: '1,000+', value: {min: 1000}}
  ];

  totalAcresOptions: SelectOption[] = <any[]>[
    {key: 'filters.land-size', value: {}, disabled: true},
    {key: 'filters.any', value: {}},
    {text: '100+', value: {min: 100}},
    {text: '1,000+', value: {min: 1000}},
    {text: '10,000+', value: {min: 10000}}
  ];

  parkingOptions: SelectOption[] = <any[]>[
    {key: 'filters.parking-spaces', value: {}, disabled: true},
    {key: 'filters.any', value: {}},
    {text: '1', value: {min: 1, max: 1}},
    {text: '2+', value: {min: 2}},
    {text: '5+', value: {min: 5}},
    {text: '10+', value: {min: 10}},
    {text: '100+', value: {min: 100}},
    {text: '1,000+', value: {min: 1000}}
  ];
  private filters: Filters;

  constructor(protected preferencesService: PreferencesService,
              protected communicationService: CommunicationService,
              protected translateService: TranslateService,
              protected router: Router,
              protected listingsService: ListingsService,
              protected fb: FormBuilder,
              protected cd: ChangeDetectorRef) {
    super(preferencesService, communicationService, translateService, router, fb, cd);
    const listingTypesControls = this.filtersForm.controls['listingTypes'] as FormGroup;
    this.listingType.forEach((it) => {
      listingTypesControls.addControl(it, this.fb.control(false));
    });
    this.filtersForm.addControl('stories', this.fb.control({}));
    this.filtersForm.addControl('size', this.fb.control({}));
    this.filtersForm.addControl('units', this.fb.control({}));
    this.filtersForm.addControl('sqft', this.fb.control({}));
    this.filtersForm.addControl('totalAcres', this.fb.control({}));
    this.filtersForm.addControl('parking', this.fb.control({}));
    this.filtersForm.addControl('priceType', this.fb.control(0));
  }

  protected _updateFiltersForm(filters: Filters) {
    this.filters = filters;
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(this.listingsService.getFilters().subscribe((result) => {
      this.addBusinessTypes(result);
    }));
    this.addSub(this.listingTypesFg.valueChanges.pipe(debounceTime(10)).subscribe((s) => {
      this.showAllListingTypes = Object.keys(s).every((k) => !s[k]);
    }));
    this.addSub(this.filtersForm.controls['priceType'].valueChanges.pipe(debounceTime(10)).subscribe((s) => {
      let minValueToSet = 0;
      let maxValueToSet = 0;
      this.isPricePerSqft = s === 1;
      if (this.isPricePerSqft) {
        if (this.filters.pricePerSqFt) {
          minValueToSet = this.filters.pricePerSqFt.min;
          maxValueToSet = this.filters.pricePerSqFt.max;
        }
      }
      else if (this.filters.price) {
        minValueToSet = this.filters.price.min;
        maxValueToSet = this.filters.price.max;
      }
      this.filtersForm.controls['minPrice'].setValue(minValueToSet || 0);
      this.filtersForm.controls['maxPrice'].setValue(maxValueToSet || 0);
      this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
    }));
  }

  onReset() {
    super.onReset();
    this.filtersForm.controls['stories'].setValue({});
    this.filtersForm.controls['size'].setValue({});
    this.filtersForm.controls['units'].setValue({});
    this.filtersForm.controls['totalAcres'].setValue({});
    this.filtersForm.controls['parking'].setValue({});
    this.filtersForm.controls['sqft'].setValue({});
    this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
  }

  clearBusinessTypes() {
    const businessTypeForm = this.businessTypesFg;
    this.businessType.forEach((it) => {
      businessTypeForm.get(it).patchValue(false);
    })
  }

  clearListingTypes() {
    const listingTypeForm = this.listingTypesFg;
    this.listingType.forEach((it) => {
      listingTypeForm.get(it).patchValue(false);
    })
  }

  /**
   * iterate through the business types received from the server and add controls to the form group
   * @param result
   */
  protected addBusinessTypes(result: string[]) {
    this.businessType = result;
    const businessTypesControls = this.fb.group({});
    this.businessType.forEach((it) => {
      businessTypesControls.addControl(it, this.fb.control(false));
    });
    this.filtersForm.addControl('businessTypes', businessTypesControls);
    this.addSub(this.businessTypesFg.valueChanges.pipe(debounceTime(10)).subscribe((s) => {
      this.showAllBusinessTypes = Object.keys(s).every((k) => !s[k]);
    }));

    // map the filters retrieved from the local storage to the form group
    if (this.filters.businessTypes) {
      Object.keys(this.filters.businessTypes).forEach(key => {
        const control = businessTypesControls.get(key);
        if (control) {
          control.patchValue(this.filters.businessTypes[key]);
        }
      });
    }
    if (this.filters.listingTypes) {
      Object.keys(this.filters.listingTypes).forEach(key => {
        const control = this.listingTypesFg.get(key);
        if (control) {
          control.patchValue(this.filters.listingTypes[key]);
        }
      });
    }
    this.filtersForm.patchValue({
      sqft: this.filters.sqft,
      stories: this.filters.stories,
      size: this.filters.size,
      units: this.filters.units,
      totalAcres: this.filters.totalAcres,
      parking: this.filters.parking,
      priceType: this.filters.priceType ? this.filters.priceType : 0,
      price: this.filters.priceType === 1 ? {min: this.filters.pricePerSqFt.min, max: this.filters.pricePerSqFt.max} : {min: this.filters.price.min, max: this.filters.price.max},
      updatedSince: this.filters.updatedSince
    });
  }

  get businessTypesFg() {
    return this.filtersForm.get('businessTypes');
  }
}
